import React from 'react';
import {
  Bold,
  Heading1,
  Heading2,
  LinkStyled,
  Paragraph,
  Span,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
} from '../../components/grid';
import { Image } from '../../components/Image';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Item, Price } from '../../containers/commerce';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';
import { Grid } from './KulsyreTilFadoel';
import { Content } from './Kulsyre';

export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="KulsyreSodastream">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Billig kulsyre til dit Sodastream-anlæg</Heading1>
          <Paragraph>
            Kulsyre til SodaStream er dyrt, men det behøver det ikke at være. En kulsyrepatron til SodaStream fra alm. forhandlere koster 100 kr. for 425 g kulsyre. Vi har udviklet en slange der kan tilkobles SodaStream maskinen i den ene ende og en standard kulsyre i den anden ende. Dette giver et billigere alternativ til de originale SodaStream kulsyre flasker, der endda holder i længere tid, så du slipper for at skulle skifte flasken så ofte. Dette sparer dig for både tid og irritationer, men ikke mindst penge.
          </Paragraph>
          <Paragraph>
            Bestil <LinkStyled to="/kulsyre">kulsyre</LinkStyled> til SodaStream hos Skafte og nyd en frisk danskvand til en brøkdel af prisen.
            Vores kulsyre er godkendt til levnedsmiddel og er derfor egnet til SodaStream, men også fadøl. Du kan derfor trygt bestille hos Skafte, hvis du skal bruge kulsyre til hverdag og fest.
            Kulsyreflaskerne findes i to størrelser på hhv. 4 kg og 6 kg, og sælges til både privat og erhverv.
            Trykket er det samme i begge størrelser af flasker, og der er desuden sjældent brug for en trykregulator.
          </Paragraph>
          <Paragraph>
            Vi anbefaler en flaske med 4 kg kulsyre til SodaStream, hvis der er tale om hjemmebrug. Hvis der derimod er tale om erhverv, kan der med fordel bestilles en flaske med 6 kg.
          </Paragraph>
          <Paragraph>
            En flaske med 4 kg svarer til ca. 10 gange mere, end hvad du får i en lille kulsyrepatron til SodaStream. Du slipper altså for at skulle skifte patron lige så ofte, hvis du vælger at købe en flaske i stedet.
            Vær opmærksom på, at en flaske med kulsyre til SodaStream fylder mere end den lille patron - til gengæld behøver du ikke at omskifte lige så ofte. Flasken har en diameter på 15,4 cm og en højde på 59 cm. Tomvægten er 7,25 kg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item varenr="21130" middleImage display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item
                varenr="8944"
                middleImage
                display={ProductViewKulsyre}
                customDescription={(
                  <React.Fragment>
                    <Paragraph>
                      <Bold>Vi anbefaler en 4kg kulsyreflaske til det meste hjemmebrug.</Bold> Du får ca. 10 gange mere kulsyre end i en almindelig sodastream patron til 100 kr.
                    </Paragraph>
                    <Paragraph>
                      Trykket i den lille Sodastreamflaske er det samme som i både vores 4kg og 6kg flasker. Derfor er det ikke nødvendigt med trykregulator.
                    </Paragraph>
                    <Paragraph>
                      Panten på flasken er <Price embPrice varenr="8940" momsIndication />
                    </Paragraph>
                    <Paragraph>
                      Aluminiumsflaske uden stigrør:<br />
                      Diameter 16cm | Højde 72cm | Tomvægt 9kg
                    </Paragraph>
                  </React.Fragment>
                )}

              />
            </Content>
            <Content product>
              <Item varenr="20601" middleImage display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="20615" middleImage display={ProductViewKulsyre} />
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Det rette tryk kulsyre til SodaStream</Heading2>
          <Paragraph>
            Trykket i danskvand er anderledes end i øl. Trykket er nemlig højere og ligger normalt mellem 5 og 6 bar.
          </Paragraph>
          <Paragraph>
            De fleste flasker med kulsyre til SodaStream købt hos Skafte har ikke brug for en regulator, men der kan være undtagelser. Her på siden finder du derfor en trykregulator, der kan skrues direkte på flasken. Den kan regulere trykket alt mellem 1 og 10 bar.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Husk ventilen til SodaStream kulsyre</Heading2>
          <Paragraph>
            Når du køber kulsyre til SodaStream hos Skafte, får du en stor flaske, der holder længere og er større end de små kulsyrepatroner til SodaStream. Der skal monteres en slange fra din SodaStream maskine til kulsyreflasken, for at denne kan anvendes. For at færdiggøre slangeforbindelsen skal ventilen fra en SodaStream eller Quooker kulsyreflaske bruges.
          </Paragraph>
          <Paragraph>
            Du kan sagtens bruge ventilen fra din egen brugte kulsyrepatron til SodaStream. Ventilen skal blot skrues ud af den lille patron og monteres i tilkoblingen i slangen. Dette skal kun gøres en enkelt gang, da både ventil og slange kan bruges igen og igen, også selvom kulsyren til SodaStream er brugt op.
          </Paragraph>
          <Paragraph>
            Hvis du ikke selv ønsker at montere ventilen eller er i tvivl om det gøres rigtigt, kan du aflevere den brugte kulsyrepatron til SodaStream hos os i forbindelse med køb af en slange. Herefter skruer vi ventilen af den gamle patron og sætter den på den nye slange. Ønskes der forsendelse af slangen, uden at aflevere en brugt SodaStream patron, sender vi blot slangen uden ventil, hvorefter den monteres selv - det er meget nemt.
          </Paragraph>
          <Paragraph>
            Slangen måler 2 meter og kan skrues direkte på flasken med kulsyre til SodaStream.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Slip for den besværlige SodaStream kulsyrepatron genopfyldning</Heading2>
          <Paragraph>
            Når der anvendes de små kulsyrepatroner til SodaStream slipper de hurtigt op, hvis du ofte nyder lækker danskvand. Patronerne kan ombyttes i mange butikker og kiosker efterhånden, men det kræver tid, at skulle ned og bytte hver gang. De er desuden også dyrere i drift, da der ikke er lige så meget indhold i, som der er i vores flasker.
            Du kan derfor spare tid og penge ved at ombytte de små patroner til en flaske med kulsyre til SodaStream købt hos Skafte.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12} sm={6} md={4}>
              <Image name="kulsyre.kulsyreSodastream3.jpg" />
              <Span block fontSize="12px" paddingTop="5px">Tilkobling mellem 4kg kulsyreflaske og Sodastream</Span>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Image name="kulsyre.kulsyreSodastream2.jpg" />
              <Span block fontSize="12px" paddingTop="5px">Direkte forbindelse fra kulsyreflaske</Span>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Image name="kulsyre.kulsyreSodastream1.jpg" />
              <Span block fontSize="12px" paddingTop="5px">Ventil fra Sodastream monteret på slange</Span>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
